export default function cssifyMediaQueryRules(mediaQuery, mediaQueryRules) {
  if (mediaQueryRules) {
    return '@media ' + mediaQuery + '{' + mediaQueryRules + '}';
  }

  return '';
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-utils/es/cssifyMediaQueryRules.js
// module id = 855
// module chunks = 0